import Controller from './controller'

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js"
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
import "@lottiefiles/lottie-player";

export default class extends Controller {
  static get targets() {
    return ['height', 'fixedchild', 'fauxchild', 'counter', 'animation']
  }

  initialize() {
    this.render = this.render.bind(this)
    this.scroll = this.scroll.bind(this)
  }

  connect() {
    this.active = -1
    this.last = -2
    
    const player = this.fixedchildTargets[0].querySelector('lottie-player')    
    if (player) {
      this.reset(player)
    }
    
    this.scroll()
    window.addEventListener('scroll', this.scroll, { passive: true })

    if (this.hasHeightTarget) {
      this.guauge()
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.scroll)

    if (this.queuedRender) cancelAnimationFrame(this.queuedRender)
  }

  scroll() {
    this.getPosition()
  }

  getPosition() {
    if (this.queuedRender) cancelAnimationFrame(this.queuedRender)
    this.queuedRender = requestAnimationFrame(this.render)
  }

  render() {
    this.active = -1
        
    for (let index = 0; index < this.fauxchildTargets.length; index++) {
      const r = this.fauxchildTargets[index].getBoundingClientRect()

      if (r.top - (r.height * 2) <= 0) {
        this.active = index
      }
    }
    
    this.go(this.active)
  }

  go(index) {
    if (index == this.last) {
      return
    }

    if (index == -1) {
      this.fixedchildTargets[0].classList.add('is-selected')
      this.fauxchildTargets[0].classList.add('is-selected')
            
      this.last = -2

      return
    }

    for (let i = 0; i < this.fixedchildTargets.length; i++) {
      this.fixedchildTargets[i].classList.remove('is-selected')
      this.fauxchildTargets[i].classList.remove('is-selected')
    }

    const player = this.fixedchildTargets[index].querySelector('lottie-player')
    if (player) {
      this.play(player)
    }
    
    if (this.hasCounterTarget) {
      this.counterTarget.style.transform = `translateY(-${this.counterTarget.parentNode.offsetHeight * this.active}px)`
    }

    this.fixedchildTargets[index].classList.add('is-selected')
    this.fauxchildTargets[index].classList.add('is-selected')
    
    this.last = index
  }
  
  play(player) {
    player.seek(0)
    player.play()
  }
  
  reset(player) {    
    player.seek(0)
    player.stop()
  }
  
  guauge() {
    gsap.to(this.heightTarget, {
      height: '100%',
      scrollTrigger: {
        trigger: this.element,
        start: "top top",
        end: "bottom bottom",
        scrub: 0,
      }
    })
  }
}
